/** The absolute `ws:`/`wss:` URL for a same-origin socket path. */
export function socketUrl(path: string): string {
  const url = new URL(path, location.origin);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url.toString();
}
